(function(){
const ROOT = document.getElementById("mab-root");

/* ============================================================
   DATA — edit freely
   ============================================================ */
const TIERS = [
  { size: 5,  save: 0.10, label: "The Starter" },
  { size: 8,  save: 0.15, label: "The Household", tag: "Most popular" },
  { size: 12, save: 0.20, label: "The Collector" },
];


// Category names/colors (swap-drawer tabs + "mix" bar). Keys match STEPS and product.cat.
const CATS = {
  traditional:{ name:"Traditional", color:"#2C3925" },
  herbal:     { name:"Perfumed",    color:"#B89447" },
  facial:     { name:"Facial",      color:"#565B50" },
  glycerine:  { name:"Glycerine",   color:"#C9A97A" },
  liquid:     { name:"Liquid",      color:"#A65039" },
  sachet:     { name:"Sachets",     color:"#8E8A6E" },
};

/* ------------------------------------------------------------
   PRODUCT DETAILS FOR THE BUILDER & QUIZ, keyed by product handle.
   Price, image, stock and availability always come live from Shopify.
   Here you only set: short blurb, quiz tags, and bestseller flag.
   Any product NOT listed still appears (in its category by product
   type) using default quiz tags for that category.

   scent: floral | fresh | warm | fruity | pure     format: bar | liquid | sachet | specialty
   skin:  sensitive | dry | oily | normal          strength: 1 (barely there) … 3 (noticeable)
   popular:true → "Bestseller" badge (top 6 by units sold over the last 6 months, Sep 2026)
   gift:true → boosted for gift shoppers    reason: custom "why it's in your box" label
   universal:true → facial bars: fit every skin type, used as fillers in any box
   cat: override the category (traditional | herbal | facial | glycerine | liquid | sachet)
   ------------------------------------------------------------ */
const DETAILS = {
  // Base (Classic bars)
  "traditional-olive-oil":  { desc:"The original 1880 family recipe. 100% olive oil, unscented.", scent:["pure"], skin:["sensitive","dry","oily","normal"], strength:1, popular:true },
  "bay-laurel-soap-10":     { desc:"Olive & bay laurel oil. Clarifying, for oily or easily irritated skin.", scent:["fresh","pure"], skin:["oily","sensitive","normal"], strength:1 },
  "motayb-soap":            { cat:"traditional", desc:"The traditional bar with a delicate, clean fragrance.", scent:["fresh"], skin:["normal","dry"], strength:1, gift:true, reason:"The original, gently perfumed", popular:true },
  "pomace-olive-oil-soap":  { desc:"Mild and unscented. An everyday bar for every sink.", scent:["pure"], skin:["normal","oily"], strength:1 },
  // Perfumed (Classic bars). Cold-pressed and conditioning, so tagged normal + dry skin.
  "lavender-soap":          { desc:"Clean and calming herbal-floral.", scent:["floral","fresh"], skin:["normal","dry"], strength:2, gift:true, popular:true },
  "oud-soap":               { desc:"Deep and woody with gentle smoky warmth.", scent:["warm"], skin:["normal","dry"], strength:3, gift:true, popular:true },
  "mint-soap":              { desc:"Cool, crisp, green brightness.", scent:["fresh"], skin:["normal","oily"], strength:2, popular:true },
  "chamomile-soap":         { desc:"Soft herbal aroma, like brewed chamomile tea.", scent:["fresh","floral"], skin:["normal","dry"], strength:1 },
  "rose-soap":              { desc:"True rose petal, fresh and natural.", scent:["floral"], skin:["normal","dry"], strength:2, gift:true },
  "jasmine-soap":           { desc:"Rich white flower, sweet and creamy.", scent:["floral"], skin:["normal","dry"], strength:3, gift:true, popular:true },
  "orange-blossom-soap":    { desc:"Light citrus floral, honeyed freshness.", scent:["floral","fruity"], skin:["normal","dry"], strength:2 },
  "musk-soap":              { desc:"Warm, smooth, subtly sweet. A soft, skin-like scent.", scent:["warm"], skin:["normal","dry"], strength:2, gift:true },
  // Facial (Classic bars). universal:true = a good filler in any box, suits every skin type,
  // never penalised for scent or strength. Charcoal and honey & wheat also match "Warm & woody".
  "activated-charcoal-soap":{ desc:"Draws out impurities and excess oil. Gentle enough for daily use.", scent:["warm"], strength:1, universal:true, reason:"Clarifying · pairs with woody scents" },
  "shea-butter-soap":       { desc:"Extra conditioning. Especially good for dry or sensitive skin.", scent:["pure"], strength:1, universal:true },
  "honey-and-wheat-soap":   { desc:"Gentle exfoliation, honey for softness.", scent:["warm"], strength:1, universal:true, reason:"Smoothing · pairs with woody scents" },
  // Glycerine & loofah (Specialty). Glycerine draws in moisture; loofah exfoliates.
  "glycerine-mango":        { desc:"Clear bar, juicy tropical scent.", scent:["fruity"], skin:["normal","dry"], strength:2 },
  "glycerine-lavender":     { desc:"Clear bar, smooth herbal lavender.", scent:["floral","fresh"], skin:["normal","dry"], strength:2 },
  "glycerine-floral":       { desc:"Clear bar, airy garden floral.", scent:["floral"], skin:["normal","dry"], strength:1 },
  "masterpiece-lavender":   { desc:"A display-worthy decorative lavender bar.", scent:["floral","fresh"], skin:["normal","dry"], strength:2, gift:true },
  "decorated":              { desc:"Clear bar with a decorative finish and a floral scent.", scent:["floral"], skin:["normal","dry"], strength:2, gift:true },
  "massage-mango":          { desc:"Textured massage bar, bright mango.", scent:["fruity"], skin:["normal","oily"], strength:2 },
  "massage-rose":           { desc:"Textured massage bar, classic rose.", scent:["floral"], skin:["normal","oily"], strength:2 },
  "glycerine-loofah-soap-mango":          { desc:"Built-in loofah for gentle exfoliation. Juicy mango.", scent:["fruity"], skin:["normal","oily"], strength:2 },
  "glycerine-loofah-soap-orange-blossom": { desc:"Built-in loofah, light citrus floral.", scent:["floral","fruity"], skin:["normal","oily"], strength:2 },
  "glycerine-loofah-soap-lavender":       { desc:"Built-in loofah, calming lavender.", scent:["floral","fresh"], skin:["normal","oily"], strength:2 },
  "glycerine-loofah-soap-floral-bouquet": { desc:"Built-in loofah, airy garden floral.", scent:["floral"], skin:["normal","oily"], strength:1 },
  // Liquid. Gentle olive-oil formula for frequent hand washing, lightly scented.
  "oud-liquid-soap":             { desc:"16.9 oz bottle. Deep, woody, refined.", scent:["warm"], skin:["sensitive","dry","oily","normal"], strength:2, gift:true },
  "orange-blossom-liquid-soap":  { desc:"16.9 oz bottle. Bright citrus floral.", scent:["floral","fruity"], skin:["sensitive","dry","oily","normal"], strength:2, gift:true },
  "mango-liquid-soap":           { desc:"16.9 oz bottle. Fresh tropical sweetness.", scent:["fruity"], skin:["sensitive","dry","oily","normal"], strength:2 },
  "jasmin-liquid-soap":          { desc:"16.9 oz bottle. Elegant white flower.", scent:["floral"], skin:["sensitive","dry","oily","normal"], strength:2 },
  // Sachets (not for skin)
  "sachet-lavender":  { desc:"For drawers, closets, and luggage.", scent:["floral","fresh"], strength:2, gift:true },
  "sachet-rose":      { desc:"True rose petal for linens.", scent:["floral"], strength:2, gift:true },
  "sachet-musk":      { desc:"Warm, skin-like musk.", scent:["warm"], strength:2, gift:true },
  "sachet-flowers":   { desc:"A light garden blend.", scent:["floral"], strength:1, gift:true },
};

// Shopify product type → builder category
const TYPE_TO_CAT = {
  "Olive Oil Soap Bar":"traditional", "Bay Laurel Soap Bar":"traditional",
  "Perfumed Soap Bar":"herbal", "Facial Soap Bar":"facial",
  "Glycerin Soap Bar":"glycerine", "Loofah Soap Bar":"glycerine",
  "Liquid Hand Soap":"liquid", "Soap Sachet":"sachet",
};
// Defaults for products that aren't listed in DETAILS
const CAT_DEFAULTS = {
  traditional:{ scent:["pure"], format:"bar", skin:["normal"], strength:1 },
  herbal:     { scent:["floral"], format:"bar", skin:["normal"], strength:2 },
  facial:     { scent:["pure"], format:"bar", skin:["normal"], strength:1 },
  glycerine:  { scent:["floral"], format:"specialty", skin:["normal"], strength:2 },
  liquid:     { scent:["floral"], format:"liquid", skin:["normal"], strength:2 },
  sachet:     { scent:["floral"], format:"sachet", skin:[], strength:2 },
};
const CAT_FORMAT = { traditional:"bar", herbal:"bar", facial:"bar", glycerine:"specialty", liquid:"liquid", sachet:"sachet" };

// Live products from Shopify (rendered by Liquid into the page)
const LIVE = JSON.parse(ROOT.querySelector("[data-mab-products]").textContent);
// Products never offered in the builder (sets / bundles that are already multi-piece)
const EXCLUDE = ["sachet-set", "create-a-custom-bunde", "traditional-olive-oil-4-pack", "traditional-olive-oil-10-pack", "scented-olive-oil-3-pack", "traditional-olive-oil-castile-soap", "bay-laurel-soap-5"];

const THEME_CARD_COPY = {"traditional-olive-oil": "The unscented original, cured for months.", "bay-laurel-soap-10": "Olive oil soap with an herbal laurel character.", "motayb-soap": "A lightly perfumed everyday olive oil bar.", "pomace-olive-oil-soap": "An everyday bar made with olive pomace oil.", "shea-butter-soap": "Olive oil soap enriched with shea butter.", "activated-charcoal-soap": "Olive oil soap with activated charcoal.", "honey-and-wheat-soap": "A facial bar with honey and milled wheat.", "masterpiece-lavender": "An ornamental glycerine soap scented with lavender.", "decorated": "A decorative bar in a surprise scent.", "sachet-set": "Four scented pouches for several spaces around the home.", "rose-soap": "Fresh rose with a soft floral finish.", "lavender-soap": "Herbal lavender, fresh and softly floral.", "oud-soap": "Warm wood with a smoky oud character.", "mint-soap": "A crisp, green mint scent.", "jasmine-soap": "A full floral scent with soft sweetness.", "chamomile-soap": "A soft herbal floral scent.", "orange-blossom-soap": "Citrus blossom with a honeyed floral note.", "musk-soap": "Warm, soft musk with a subtle sweetness.", "glycerine-mango": "Clear glycerine soap with a tropical mango scent.", "glycerine-floral": "A clear bar with a garden-floral scent.", "glycerine-lavender": "Herbal lavender in a clear glycerine bar.", "glycerine-loofah-soap-orange-blossom": "Citrus-floral glycerine soap with a loofah center.", "glycerine-loofah-soap-mango": "A fruity mango wash with a textured scrub.", "glycerine-loofah-soap-lavender": "Herbal lavender with a natural loofah scrub.", "glycerine-loofah-soap-floral-bouquet": "A floral wash with a loofah center.", "orange-blossom-liquid-soap": "Citrus blossom fragrance for the washbasin.", "oud-liquid-soap": "A woody oud scent in liquid form.", "mango-liquid-soap": "A bright mango scent for everyday handwashing.", "jasmin-liquid-soap": "A floral jasmine scent beside the sink.", "sachet-lavender": "Lavender-scented soap shavings for drawers and closets.", "sachet-rose": "A softly floral scent for the linen cupboard.", "sachet-flowers": "A bouquet-style fragrance for drawers and closets.", "sachet-musk": "A warm musk scent for small storage spaces."};
const PRODUCTS = LIVE.map(raw => {
  if (EXCLUDE.includes(raw.handle)) return null;
  const d = DETAILS[raw.handle] || {};
  const cat = d.cat || TYPE_TO_CAT[raw.type];
  if (!cat) return null;                               // not a builder product (e.g. bundles, gift sets)
  const def = CAT_DEFAULTS[cat];
  return {
    id: raw.handle,
    variantId: raw.variant_id,
    name: raw.title,
    cat,
    price: raw.price / 100,
    image: raw.image,
    url: raw.url,
    desc: THEME_CARD_COPY[raw.handle] || d.desc || raw.blurb,
    scent: d.scent || def.scent,
    format: d.format || CAT_FORMAT[cat],
    skin: d.universal ? ["sensitive","dry","oily","normal"] : (d.skin || def.skin),
    strength: d.strength || def.strength,
    popular: !!d.popular,
    gift: !!d.gift,
    universal: !!d.universal,
    reason: d.reason || null,
    soldOut: !raw.available,
    max: raw.max == null ? 99 : raw.max,                // stock cap when inventory is tracked
  };
}).filter(Boolean);
const TRADITIONAL_ID = (PRODUCTS.find(p => p.id === "traditional-olive-oil") || PRODUCTS.find(p => p.cat === "traditional") || {}).id;

// Builder steps, in order. suggest = recommended picks per box size.
const STEPS = [
  { key:"traditional", nav:"The base",     arabic:"الأساس",          title:"Start with a bar you will reach for every day",           copy:"Choose the unscented Traditional original, bay laurel, Pomace, or gently perfumed Motayab. Every category is optional; make the mix your own.", suggest:{5:1, 8:2, 12:2} },
  { key:"herbal",      nav:"Perfumed",     arabic:"معطّر في طرابلس",  title:"Follow a favorite scent", copy:"Choose florals, herbs, warm musk, or woody oud. Add one familiar scent or try a few side by side.", suggest:{5:2, 8:3, 12:4} },
  { key:"facial",      nav:"For the face", arabic:"للعناية بالبشرة",  title:"Compare the facial formulas",       copy:"Explore shea butter, charcoal, and honey and wheat. Check the ingredients of each bar before adding it.", suggest:{5:1, 8:1, 12:2} },
  { key:"glycerine",   nav:"Glycerine",    arabic:"غليسرين",         title:"Add a clear bar or a decorative piece",            copy:"Explore fruit and floral scents in glycerine soap, including ornamental options for a gift or guest basin.", suggest:{5:1, 8:1, 12:2} },
  { key:"liquid",      nav:"Liquid",       arabic:"صابون سائل",      title:"Choose a scent for the sink",                copy:"Add a pump bottle if you prefer liquid hand soap in the bathroom or kitchen.", suggest:{5:0, 8:1, 12:1} },
  { key:"sachet",      nav:"Sachets",      arabic:"أكياس معطّرة",    title:"Save a scent for the linen cupboard",      copy:"Add a pouch of perfumed soap shavings for a dry drawer or closet. Sachets are for fragrance, not washing.", suggest:{5:0, 8:0, 12:1} },
];

// Quiz. type "single" auto-advances; "multi" needs Continue (max = optional cap).
const QUESTIONS = [
  { key:"size", type:"single", arabic:"كم قطعة؟", title:"How many pieces are you after?", sub:"Bigger boxes save more.", big:true,
    options: TIERS.map(t=>({ v:t.size, t:String(t.size), d:`${t.label} · save ${t.save*100}%` })) },
  { key:"scent", type:"multi", max:3, arabic:"الروائح", title:"Which scents do you usually reach for?", sub:"Pick up to three.",
    options:[
      { v:"floral", ic:"✿", t:"Floral", d:"Rose, jasmine, orange blossom" },
      { v:"fresh",  ic:"❦", t:"Fresh & herbal", d:"Mint, lavender, chamomile, laurel" },
      { v:"warm",   ic:"◐", t:"Warm & woody", d:"Oud and musk" },
      { v:"fruity", ic:"◍", t:"Fruity & bright", d:"Mango, citrus" },
      { v:"pure",   ic:"○", t:"Pure & unscented", d:"Bars with no added fragrance" },
    ]},
  { key:"format", type:"multi", arabic:"الأشكال", title:"What formats do you want in the box?", sub:"Choose as many as you like.",
    options:[
      { v:"bar",       ic:"▢", t:"Classic bars", d:"Olive oil, perfumed, and facial bars" },
      { v:"liquid",    ic:"▯", t:"Liquid soap", d:"Pump bottles for the sink" },
      { v:"specialty", ic:"◇", t:"Specialty", d:"Clear glycerine & loofah bars" },
      { v:"sachet",    ic:"◫", t:"Drawer sachets", d:"Perfumed soap in linen" },
    ]},
  { key:"variety", type:"single", arabic:"", title:"How much variety would you like?", sub:"Choose the mix you would enjoy opening.",
    options:[
      { v:"favorites", t:"A few favorites repeated", d:"More than one of the scents I like" },
      { v:"variety", t:"As much variety as possible", d:"Different pieces to explore" },
      { v:"balanced", t:"A balance of both", d:"Some discoveries and some repeats" },
    ]},
  { key:"strength", type:"single", arabic:"قوة العطر", title:"How strong do you like a scent?", sub:"",
    options:[
      { v:1, t:"Barely there", d:"A light scent after you rinse" },
      { v:2, t:"Balanced", d:"Noticeable, never overpowering" },
      { v:3, t:"Noticeable", d:"I want to smell it in the room" },
    ]},
  { key:"who", type:"single", arabic:"لمن؟", title:"Who is this box for?", sub:"",
    options:[
      { v:"me", t:"For me", d:"My own daily routine" },
      { v:"home", t:"The whole household", d:"Every sink and shower" },
      { v:"gift", t:"A gift", d:"Something to give" },
    ]},
];

/* ============================================================
   SHARED STATE — one box used by both paths
   ============================================================ */
let size = null;      // 5 | 8 | 12
let picks = [];       // product ids, one per slot
let quizDone = false; // true once the quiz has produced a box
let answers = { scent:[], format:[], variety:null, strength:null, who:null };
let stepIdx = 0, qi = 0, swapIdx = null, drTab = "all", current = "home";

const $ = id => document.getElementById("mab-" + id);
const money = n => "$" + n.toFixed(2).replace(/\.00$/, "");
const byId = id => PRODUCTS.find(p => p.id === id);
const img = (p) => p.image || "";
const tier = () => TIERS.find(t => t.size === size);
const count = id => picks.filter(x => x === id).length;
const catCount = key => picks.filter(id => byId(id).cat === key).length;
const full = () => size && picks.length >= size;
const pad = n => String(n).padStart(2, "0");
// Price with the box discount: once a box size is chosen, show the full price crossed out
// next to the discounted price (matches what the Bundle Box discount takes off at checkout).
const boxPrice = amount => tier() ? amount * (1 - tier().save) : amount;
const priceHTML = (amount, cls = "mab-price") => tier()
  ? `<span class="${cls} mab-deal"><s>${money(amount)}</s><b>${money(boxPrice(amount))}</b></span>`
  : `<span class="${cls}">${money(amount)}</span>`;

function toast(msg){ const t=$("toast"); t.textContent=msg; t.classList.add("mab-show"); clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove("mab-show"),2000); }

function totals(){
  const sub = picks.reduce((s,id)=>s+byId(id).price,0);
  const disc = tier() ? sub*tier().save : 0;
  return { sub, disc, total: sub-disc };
}

/* ---------- views ---------- */
function show(view){
  current = view;
  ROOT.querySelectorAll(".mab-view").forEach(v => v.classList.toggle("mab-show", v.id === "mab-" + view));
  $("modebar").classList.toggle("mab-show", view !== "home");
  const quizSide = ["quiz","loading","result"].includes(view);
  $("mbBuild").classList.toggle("mab-on", !quizSide);
  $("mbQuiz").classList.toggle("mab-on", quizSide);
  closeDrawer();
  scrollToRoot();
}

/* ============================================================
   PATH A — BUILDER
   ============================================================ */
function goBuild(fromQuiz){
  if (fromQuiz) stepIdx = 0;
  show("build");
  $("fromQuiz").classList.toggle("mab-show", quizDone && picks.length > 0);
  $("quizNudge").style.display = quizDone ? "none" : "";
  $("builder").classList.toggle("mab-locked", !size);
  renderSizes(); renderBuilder();
  if (fromQuiz) setTimeout(()=>scrollToEl($("builder"), true), 50);
}

function renderSizes(){
  $("heroTiers").innerHTML = TIERS.map(t=>`<div><b>${t.size}</b><small>Save ${t.save*100}%</small></div>`).join("");
  $("sizes").innerHTML = TIERS.map((t,i)=>`
    <button class="mab-size ${size===t.size?'mab-on':''}" onclick="MAB.chooseSize(${i})">
      ${t.tag?`<span class="mab-tag">${t.tag}</span>`:""}
      <div class="mab-n">${t.size}</div>
      <div class="mab-lbl">${t.label}</div>
      <span class="mab-save">Save ${t.save*100}%</span>
      <div class="mab-dots">${"<i></i>".repeat(t.size)}</div>
    </button>`).join("");
}

function chooseSize(i){
  const first = !size;
  size = TIERS[i].size;
  if (picks.length > size){ picks = picks.slice(0, size); toast("Box made smaller, so the last few picks were removed"); }
  $("builder").classList.remove("mab-locked");
  renderSizes(); renderBuilder();
  if (first) scrollToEl($("builder"), true);
}

function add(id){
  if (!size) return toast("Choose a box size to begin.");
  if (full()) return toast("Your box is full. Remove a piece or choose a larger box to add something else.");
  const p = byId(id);
  if (count(id) >= p.max) return toast(`Only ${p.max} of ${p.name} in stock`);
  picks.push(id); renderBuilder();
}
function remove(id){ const i=picks.lastIndexOf(id); if(i>-1){ picks.splice(i,1); renderBuilder(); } }
function removeAt(i){ picks.splice(i,1); renderBuilder(); }

function renderBuilder(){ renderStepper(); renderStep(); renderPanel(); }

function renderStepper(){
  $("stepper").innerHTML = STEPS.map((s,i)=>{
    const c = catCount(s.key);
    return `<button class="${i===stepIdx?'mab-on':''}" onclick="MAB.goStep(${i})">
      <span class="mab-num">${pad(i+1)}</span><span class="mab-nm">${s.nav}</span>
      ${c?`<span class="mab-cnt">${c}</span>`:""}</button>`;
  }).join("");
  const bar = $("stepper"), on = bar.querySelector(".mab-on");
  if (on && bar.scrollWidth > bar.clientWidth){
    const b = bar.getBoundingClientRect(), r = on.getBoundingClientRect();
    bar.scrollLeft += (r.left - b.left) - (b.width - r.width) / 2;
  }
}

function renderStep(){
  const s = STEPS[stepIdx];
  // If the quiz was taken, best matches float to the top; otherwise bestsellers do.
  const items = PRODUCTS.filter(p=>p.cat===s.key).sort((a,b)=>
    (!!a.soldOut-!!b.soldOut) || ((a.id===TRADITIONAL_ID?0:1)-(b.id===TRADITIONAL_ID?0:1)) || (quizDone ? scoreProduct(b)-scoreProduct(a) : (!!b.popular-!!a.popular)));
  const sug = size ? s.suggest[size] : 0;
  $("stepBody").innerHTML = `
    <div class="mab-step-head">
      <div><div class="mab-arabic">${s.arabic}</div><h2>${s.title}</h2><p>${s.copy}</p>${tier()?`<p class="mab-deal-note">Prices shown with your ${tier().save*100}% box discount</p>`:""}</div>
      ${sug?`<div class="mab-suggest">Suggested for ${size}: <b>${sug}</b></div>`:`<div class="mab-suggest">Optional</div>`}
    </div>
    <div class="mab-grid">${items.map(card).join("")}</div>`;
  $("prevBtn").disabled = stepIdx===0;
  $("nextBtn").textContent = stepIdx===STEPS.length-1 ? "Review box →" : "Next: " + STEPS[stepIdx+1].nav + " →";
}

function card(p){
  const q = count(p.id);
  const badges = [];
  if (p.soldOut) badges.push(`<span class="mab-badge mab-out">Sold out</span>`);
  else {
    if (quizDone && scoreProduct(p) >= 4) badges.push(`<span class="mab-badge mab-match">Quiz match</span>`);
    if (p.popular) badges.push(`<span class="mab-badge mab-pop">Bestseller</span>`);
  }
  const ctrl = p.soldOut ? `<span class="mab-price" style="color:var(--muted)">Unavailable</span>`
    : q ? `<div class="mab-qty"><button onclick="MAB.remove('${p.id}')">−</button><span>${q}</span><button onclick="MAB.add('${p.id}')" ${full()?"disabled":""}>+</button></div>`
        : `<button class="mab-add" onclick="MAB.add('${p.id}')" ${full()?"disabled":""}>Add</button>`;
  return `<div class="mab-card ${q?'mab-picked':''} ${p.soldOut?'mab-out':''}">
    <div class="mab-badges">${badges.join("")}</div>
    <div class="mab-img"><img src="${img(p)}" alt="${p.name}" loading="lazy"></div>
    <div class="mab-body"><h3>${p.name}</h3><div class="mab-desc">${p.desc}</div>
      <div class="mab-row">${priceHTML(p.price)}${ctrl}</div></div></div>`;
}

function renderPanel(){
  const n = picks.length, sz = size || 0;
  $("meter").style.width = sz ? (n/sz*100)+"%" : "0";
  $("meterTxt").textContent = sz ? `${n} of ${sz} pieces chosen` : "Choose a box size to begin";
  $("tierTxt").textContent = tier() ? `Save ${tier().save*100}%` : "";
  $("slots").style.gridTemplateColumns = `repeat(${sz<=5?5:4},1fr)`;
  $("slots").innerHTML = Array.from({length:sz},(_,i)=>{
    const p = picks[i] && byId(picks[i]);
    return p ? `<div class="mab-slot mab-filled" title="${p.name}"><img src="${img(p,160)}" alt=""><button class="mab-x" onclick="MAB.removeAt(${i})">×</button></div>`
             : `<div class="mab-slot"><span>${i+1}</span></div>`;
  }).join("");
  const grouped = [...new Set(picks)].map(id=>({p:byId(id), q:count(id)}));
  $("lines").innerHTML = grouped.length
    ? `<div class="mab-lines">${grouped.map(g=>`<div class="mab-line"><span>${g.p.name}</span><em>×${g.q} · ${priceHTML(g.p.price*g.q, "mab-line-price")}</em></div>`).join("")}</div>`
    : `<p class="mab-empty">Your box is empty. Choose your first piece.</p>`;
  const t = totals(), left = sz-n;
  if (!sz) { $("totals").innerHTML = ""; $("mbarTxt").textContent = "Choose a box size"; return; }
  $("totals").innerHTML = `
    <div><span>Price before discount</span><span>${money(t.sub)}</span></div>
    <div class="mab-disc"><span>Bundle savings</span><span>−${money(t.disc)}</span></div>
    <div class="mab-grand"><span>Total before shipping and tax</span><span>${money(t.total)}</span></div>
    <button class="mab-btn mab-btn-dark" ${left || !sz?"disabled":""} onclick="MAB.showReview()">${left?`Add ${left} more`:"Review your box →"}</button>
    <p class="mab-ship">${t.total>35?"✦ Free U.S. shipping":"Free U.S. shipping over $35"}</p>`;
  $("mbarTxt").textContent = `${n}/${sz} · ${money(t.total)}`;
}

function goStep(i){ stepIdx=i; renderBuilder(); scrollToEl($("stepper"), true); }
$("prevBtn").onclick = ()=> stepIdx>0 && goStep(stepIdx-1);
$("nextBtn").onclick = ()=> stepIdx<STEPS.length-1 ? goStep(stepIdx+1) : (full()?showReview():toast(`Add ${size-picks.length} more to finish`));

function showReview(){
  if (!full()) return toast("Choose enough pieces to finish your box.");
  const t = totals();
  const grouped = [...new Set(picks)].map(id=>({p:byId(id), q:count(id)}));
  $("reviewBody").innerHTML = `
    <div class="mab-eyebrow">Your box is ready</div>
    <h2 style="font-size:clamp(34px,5vw,56px);margin-top:10px">${tier().label} · ${size} pieces</h2>
    <div class="mab-review-grid">${grouped.map(g=>`
      <div class="mab-card"><div class="mab-badges"><span class="mab-badge">×${g.q}</span></div><div class="mab-img"><img src="${img(g.p)}" alt=""></div>
      <div class="mab-body"><h3>${g.p.name}</h3>${priceHTML(g.p.price*g.q)}</div></div>`).join("")}</div>
    <div style="display:flex;gap:30px;align-items:center;flex-wrap:wrap;border-top:1px solid var(--line);padding-top:24px">
      <div><span style="text-decoration:line-through;color:var(--muted)">${money(t.sub)}</span>
        <span style="font-family:var(--serif);font-size:34px;margin-left:10px">${money(t.total)}</span>
        <span style="color:var(--clay);font-family:var(--sans);font-size:12px;margin-left:8px">You save ${money(t.disc)}</span></div>
      <button class="mab-btn mab-btn-dark" onclick="MAB.addToBag(this)">Add box to bag</button>
      <button class="mab-btn mab-btn-line" onclick="MAB.goBuild()">Keep editing</button>
    </div>`;
  show("review");
}

/* ============================================================
   PATH B — QUIZ
   ============================================================ */
const getAns = k => k==="size" ? size : answers[k];
const setAns = (k,v) => { if (k==="size") size = v; else answers[k] = v; };

function startQuiz(){
  // Already have a quiz result? The tab returns to it instead of restarting.
  if (quizDone && current !== "result") { renderResult(); show("result"); return; }
  qi = 0; show("quiz"); renderQ();
}
function restartQuiz(){ answers = { scent:[], format:[], variety:null, strength:null, who:null }; quizDone=false; qi=0; show("quiz"); renderQ(); }

function renderQ(){
  const q = QUESTIONS[qi], val = getAns(q.key);
  const on = v => q.type==="multi" ? val.includes(v) : val===v;
  const canNext = q.type==="multi" ? val.length>0 : val!==null;
  $("qWrap").innerHTML = `
    <div class="mab-progress">${QUESTIONS.map((_,i)=>`<i class="${i<=qi?'mab-done':''}"></i>`).join("")}</div>
    <div class="mab-q-top"><span>Question ${qi+1} of ${QUESTIONS.length}</span><span class="mab-arabic" style="font-size:16px;letter-spacing:0">${q.arabic}</span></div>
    <h2 class="mab-q-title">${q.title}</h2>
    ${q.sub?`<p class="mab-q-sub">${q.sub}</p>`:`<div style="height:24px"></div>`}
    <div class="mab-opts">${q.options.map((o,i)=>`
      <button class="mab-opt ${q.big?'mab-big':''} ${on(o.v)?'mab-on':''}" onclick="MAB.pick(${i})">
        ${q.type==="multi"?`<span class="mab-chk">${on(o.v)?"✓":""}</span>`:""}
        ${o.ic?`<span class="mab-ic">${o.ic}</span>`:""}
        <span class="mab-t">${o.t}</span><span class="mab-d">${o.d}</span>
      </button>`).join("")}</div>
    <div class="mab-q-nav">
      <button class="mab-btn mab-btn-line" onclick="${qi?'MAB.prevQ()':"MAB.show('home')"}">← Back</button>
      <span class="mab-q-skip">Rather choose yourself? <button onclick="MAB.goBuild()">Build it yourself</button></span>
      <button class="mab-btn mab-btn-dark" onclick="MAB.nextQ()" ${canNext?"":"disabled"}>${qi===QUESTIONS.length-1?"See my box →":"Continue →"}</button>
    </div>`;
}

function pick(i){
  const q = QUESTIONS[qi], v = q.options[i].v;
  if (q.type==="multi"){
    const arr = answers[q.key];
    if (arr.includes(v)) arr.splice(arr.indexOf(v),1);
    else { if (q.max && arr.length>=q.max) arr.shift(); arr.push(v); }
    renderQ();
  } else { setAns(q.key, v); renderQ(); setTimeout(nextQ, 220); }
}
function prevQ(){ qi--; renderQ(); }
function nextQ(){
  if (qi < QUESTIONS.length-1){ qi++; renderQ(); scrollToRoot(true); return; }
  show("loading");
  setTimeout(()=>{ quizDone = true; rebuild(false); show("result"); }, 1100);
}

/* ---------- matching (edit weights here; higher = better fit) ---------- */
function scoreProduct(p){
  if (p.soldOut) return -99;
  const fmts = answers.format.length ? answers.format : ["bar"];
  let score = fmts.includes(p.format) ? 6 : -6;
  score += p.scent.filter(x=>answers.scent.includes(x)).length * 4;
  if (answers.scent.length && !p.scent.some(x=>answers.scent.includes(x))) score -= 3;
  score -= Math.abs((answers.strength || 2) - p.strength);
  if (answers.who === "gift" && p.gift) score += 1;
  if (answers.who === "home" && (p.cat === "traditional" || p.cat === "liquid")) score += 1;
  return score;
}

function reasonFor(p){
  const hit = p.scent.find(x=>answers.scent.includes(x));
  if (closestIds.has(p.id)) return "Another option in your chosen format";
  if (hit) return {floral:"Floral match",fresh:"Herbal scent match",warm:"Woody or musk match",fruity:"Fruit scent match",pure:"No added fragrance"}[hit];
  return "A starting suggestion to explore";
}

let closestIds = new Set();   // picks that fill a requested format with no exact scent match

function buildBox(shuffle){
  const out = [];
  closestIds = new Set();
  const fmts = answers.format.length ? answers.format : ["bar"];
  const pureOnly = answers.scent.length === 1 && answers.scent[0] === "pure";
  const noStrong = answers.strength === 1;
  const pool = PRODUCTS.filter(p=>!p.soldOut && p.max > 0 && fmts.includes(p.format) && (!pureOnly || p.scent.includes("pure")) && (!noStrong || p.strength < 3))
    .map(p=>({p, score:scoreProduct(p)+(shuffle ? Math.random()*2 : 0)})).sort((a,b)=>b.score-a.score).map(x=>x.p);
  const used = id=>out.filter(x=>x===id).length;
  const add = p=>{ if (out.length < size && used(p.id) < p.max) out.push(p.id); };
  const exact = p=>!answers.scent.length || p.scent.some(x=>answers.scent.includes(x));
  const exactPool = pool.filter(exact);
  for (const format of fmts) { const p=exactPool.find(p=>p.format===format); if(p) add(p); }
  const maxUnique = answers.variety === "favorites" ? Math.max(2, Math.ceil(size/3)) : answers.variety === "balanced" ? Math.ceil(size*.7) : size;
  for (const p of exactPool) { if(new Set(out).size>=maxUnique) break; if(!used(p.id)) add(p); }
  for (let round=0;round<size && out.length<size;round++) for(const p of exactPool) if(used(p.id)) add(p);
  for (const p of pool) { if(out.length>=size) break; if(!used(p.id)){ add(p); if(!exact(p)) closestIds.add(p.id); } }
  for (let round=0;round<size && out.length<size;round++) for(const p of pool){ add(p); if(!exact(p)) closestIds.add(p.id); }
  return out;
}

function rebuild(shuffle){ picks = buildBox(shuffle); renderResult(); if (shuffle) toast("New picks, same preferences"); }

/* ---------- result ---------- */
function renderResult(){
  const t = tier();
  const scentNames = answers.scent.map(s=>QUESTIONS[1].options.find(o=>o.v===s).t.toLowerCase());
  const scentTxt = scentNames.length ? scentNames.join(", ").replace(/, ([^,]*)$/," and $1") : "a little of everything";
  const who = { me:"your own daily routine", home:"every sink and shower in the house", gift:"giving as a gift" }[answers.who] || "your home";
  $("boxName").textContent = t.label;
  $("boxBlurb").textContent = `${t.size} pieces from the Tripoli workshop, mostly ${scentTxt}, picked for ${who}. Review the ingredients and scents, and swap anything you like before adding your box to the bag.`;
  $("chips").innerHTML = [
    ...answers.scent.map(s=>QUESTIONS[1].options.find(o=>o.v===s).t),
    ...answers.format.map(f=>QUESTIONS[2].options.find(o=>o.v===f).t),
    answers.variety && QUESTIONS[3].options.find(o=>o.v===answers.variety).t,
  ].filter(Boolean).map(c=>`<span class="mab-chip">${c}</span>`).join("");
  $("sizeSwitch").innerHTML = TIERS.map(x=>`<button class="${x.size===size?'mab-on':''}" onclick="MAB.resize(${x.size})"><b>${x.size}</b><small>Save ${x.save*100}%</small></button>`).join("");

  const slots = picks.map((id,i)=>{ const p=byId(id); return `
    <div class="mab-item" style="animation-delay:${i*40}ms">
      <span class="mab-num">${pad(i+1)}</span>
      <div class="mab-img"><img src="${img(p)}" alt="${p.name}" loading="lazy"></div>
      <div class="mab-body">
        <div class="mab-why">${reasonFor(p)}</div>
        <h3>${p.name}</h3>
        <div class="mab-row">${priceHTML(p.price)}
          <div class="mab-acts"><button class="mab-mini mab-x" onclick="MAB.removeItem(${i})" title="Remove">✕</button><button class="mab-mini" onclick="MAB.openDrawer(${i})">Swap</button></div>
        </div>
      </div>
    </div>`; });
  for (let i=picks.length;i<size;i++) slots.push(`<button class="mab-empty-slot" onclick="MAB.openDrawer(null)"><span><b>+</b>Add a piece</span></button>`);
  $("boxGrid").innerHTML = slots.join("");
  renderSummary();
}

function renderSummary(){
  const t = totals(), left = size - picks.length;
  $("sumTitle").textContent = `${picks.length} of ${size} pieces`;
  const counts = {}; picks.forEach(id=>{ const c=byId(id).cat; counts[c]=(counts[c]||0)+1; });
  $("mixBar").innerHTML = Object.entries(counts).map(([c,n])=>`<i style="width:${n/picks.length*100}%;background:${CATS[c].color}"></i>`).join("");
  $("legend").innerHTML = Object.entries(counts).map(([c,n])=>`<span style="--c:${CATS[c].color}">${CATS[c].name} ${n}</span>`).join("");
  $("tot").innerHTML = `
    <div><span>Price before discount</span><span>${money(t.sub)}</span></div>
    <div class="mab-disc"><span>Bundle savings (${tier().save*100}%)</span><span>−${money(t.disc)}</span></div>
    <div class="mab-grand"><span>Total before shipping and tax</span><span>${money(t.total)}</span></div>
    <button class="mab-btn mab-btn-dark" ${left?"disabled":""} onclick="MAB.addToBag(this)">${left?`Add ${left} more to finish`:"Add box to bag"}</button>
    <p class="mab-ship">${t.total>35?"✦ Free U.S. shipping":"Free U.S. shipping over $35"}</p>`;
}

function resize(n){
  size = n;
  if (picks.length > n) picks = picks.slice(0,n);
  else {                                   // keep current picks, top up with best matches
    const pool = buildBox(false);
    picks.forEach(id=>{ const i=pool.indexOf(id); if(i>-1) pool.splice(i,1); });
    picks = picks.concat(pool.slice(0, n - picks.length));
    // (if stock runs short the box is left with empty slots to fill by hand)
  }
  renderResult();
}
function removeItem(i){ picks.splice(i,1); renderResult(); }

/* ---------- swap drawer ---------- */
function openDrawer(i){
  swapIdx = i;
  const cur = i!==null ? byId(picks[i]) : null;
  drTab = cur ? cur.cat : "all";
  $("drLabel").textContent = cur ? "Swap piece " + pad(i+1) : "Add a piece";
  $("drTitle").textContent = cur ? `Replace ${cur.name}` : "Pick something to add";
  renderDrawer();
  $("scrim").classList.add("mab-show"); $("drawer").classList.add("mab-show");
}
function closeDrawer(){ $("scrim").classList.remove("mab-show"); $("drawer").classList.remove("mab-show"); }
function setTab(k){ drTab=k; renderDrawer(); }

function renderDrawer(){
  $("drTabs").innerHTML = [["all","Best matches"],...Object.entries(CATS).map(([k,v])=>[k,v.name])]
    .map(([k,n])=>`<button class="${drTab===k?'mab-on':''}" onclick="MAB.setTab('${k}')">${n}</button>`).join("");
  const curId = swapIdx!==null ? picks[swapIdx] : null;
  let list = PRODUCTS.filter(p=>drTab==="all"||p.cat===drTab)
    .map(p=>({p,s:scoreProduct(p)})).sort((a,b)=>(!!a.p.soldOut-!!b.p.soldOut)||b.s-a.s);
  if (drTab==="all") list = list.slice(0,10);
  $("drList").innerHTML = list.map(({p,s})=>{
    const m = p.soldOut ? `<span class="mab-m mab-other">Sold out</span>` : s>=4 ? `<span class="mab-m mab-great">Great match</span>` : s>=1 ? `<span class="mab-m mab-good">Good match</span>` : `<span class="mab-m mab-other">Something different</span>`;
    const inBox = count(p.id);
    return `<div class="mab-alt ${p.id===curId||p.soldOut?'mab-cur':''}">
      <img src="${img(p,160)}" alt="">
      <div>${m}<h4>${p.name}</h4><p>${p.desc} · ${priceHTML(p.price, "mab-inline-price")}${inBox?` · <b>${inBox} in box</b>`:""}</p></div>
      <button class="mab-mini" onclick="MAB.choose('${p.id}')">${p.id===curId?"Current":swapIdx!==null?"Swap in":"Add"}</button>
    </div>`;
  }).join("");
}
function choose(id){
  const swapping = swapIdx!==null, p = byId(id);
  const already = count(id) - (swapping && picks[swapIdx]===id ? 1 : 0);
  if (already >= p.max) return toast(`Only ${p.max} of ${p.name} in stock`);
  if (swapping) picks[swapIdx] = id; else picks.push(id);
  closeDrawer(); renderResult(); toast(`${byId(id).name} ${swapping?"swapped in":"added"}`);
}
document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeDrawer(); });

/* ============================================================
   ADD TO BAG — adds every piece as its real product, tagged with a
   hidden _bundle_id so the Bundle Box discount app can find them.
   ============================================================ */
let adding = false;
async function addToBag(btn){
  if (adding || !full()) return;
  adding = true;
  const label = btn ? btn.textContent : "";
  if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
  const boxId = "BX-" + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2,5).toUpperCase();
  const qty = {};
  picks.forEach(id => { qty[id] = (qty[id]||0) + 1; });
  const items = Object.entries(qty).map(([id, q]) => ({
    id: byId(id).variantId,
    quantity: q,
    properties: {
      "Bundle box": `${size} pieces · ${tier().save*100}% off`,
      "_bundle_id": boxId,
      "_bundle_size": String(size),
    },
  }));
  try {
    const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || "Could not add the box");
    const cart = await (await fetch("/cart.js", { headers:{ "Accept":"application/json" } })).json();
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
    ROOT.querySelectorAll("[data-mab-bag-count]").forEach(n => n.textContent = cart.item_count);
    const opened = typeof window.maOpenQuickCart === "function" && window.maOpenQuickCart();
    toast("Your box is in the bag");
    if (!opened) window.location.href = "/cart";
  } catch (e) {
    toast(e.message || "Something went wrong. Please try again.");
  } finally {
    adding = false;
    if (btn) { btn.disabled = false; btn.textContent = label; }
  }
}

// Height of whatever the theme pins to the top of the screen (header + announcement), so
// scrolling lands content just below it instead of underneath it.
function headerOffset(){
  let bottom = 0;
  document.querySelectorAll(".shopify-section-group-header-group, header.header").forEach(el => {
    const pos = getComputedStyle(el).position;
    if (pos === "sticky" || pos === "fixed") bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
  });
  return Math.max(0, bottom) + 12;
}
function scrollToEl(el, smooth, onlyUp){
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.scrollY - headerOffset();
  if (onlyUp && window.scrollY <= y) return;
  window.scrollTo({ top: Math.max(0, y), behavior: smooth ? "smooth" : "auto" });
}
function scrollToRoot(smooth){ scrollToEl(ROOT, smooth, true); }
function scrollPanel(){ scrollToEl($("panel"), true); }

// Functions used by onclick="MAB.xxx()" in the markup
window.MAB = { goBuild, startQuiz, show, chooseSize, add, remove, removeAt, goStep, showReview,
  pick, prevQ, nextQ, restartQuiz, rebuild, resize, removeItem, openDrawer, closeDrawer,
  setTab, choose, addToBag, scrollPanel };

/* ---------- init ---------- */
renderSizes();

})();

